import React from 'react';
import { cn } from '@/lib/utils';

interface MobileBadgeProps {
    children: React.ReactNode;
    variant?: 'default' | 'secondary' | 'success' | 'warning' | 'destructive';
    className?: string;
}

export function MobileBadge({
    children,
    variant = 'default',
    className
}: MobileBadgeProps) {
    const variantClasses = {
        default: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        success: 'bg-green-500/20 text-green-400',
        warning: 'bg-yellow-500/20 text-yellow-400',
        destructive: 'bg-destructive/20 text-destructive',
    };

    return (
        <span
            className={cn(
                'inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-medium rounded-full',
                variantClasses[variant],
                className
            )}
        >
            {children}
        </span>
    );
}
